import { PropsWithChildren } from 'react';
import { Link, LinkProps } from '@ardoq/link';
import { DecoratorWrapper } from './atoms';
import { TextOverflow, TextOverflowProps } from '@ardoq/popovers';
import styled from 'styled-components';
import { focusOutline } from '@ardoq/style-helpers';

type StyledLinkDecoratorProps = { $maxWidth?: number };

export type LinkDecoratorProps = PropsWithChildren<
  Pick<
    LinkProps,
    | 'onClick'
    | 'hideIcon'
    | 'href'
    | 'target'
    | 'rel'
    | 'underlineOnHover'
    | 'color'
  >
> & { maxWidth?: number } & Pick<TextOverflowProps, 'lineClamp'>;

const StyledDecoratorWrapper = styled(
  DecoratorWrapper
)<StyledLinkDecoratorProps>`
  max-width: ${({ $maxWidth }) => ($maxWidth ? `${$maxWidth}px` : '100%')};
  a {
    padding: 0 2px;
    &:focus-visible,
    &:focus {
      ${focusOutline};
    }
  }
`;

export const LinkDecorator = ({
  children,
  maxWidth,
  lineClamp,
  ...props
}: LinkDecoratorProps) => (
  <StyledDecoratorWrapper $maxWidth={maxWidth}>
    <TextOverflow lineClamp={lineClamp}>
      <Link typography="text2" {...props}>
        {children || props.href}
      </Link>
    </TextOverflow>
  </StyledDecoratorWrapper>
);
